$(document).ready(function(){
  
  
  if(document.getElementById("illuvideo") != null || document.getElementById("illuvideoMobile") != null) { 
    //only one of these can/shall be tru at any given time
    var pt_DTvideoisloaded = false;
    var pt_MDvideoisloaded = false;
    var pt_SMvideoisloaded = false;
    
    $(window).on('resize', function() {
      var myvid ="";
      
      var windowWidth = $(window).width();
    
      if (windowWidth > 991 && !pt_DTvideoisloaded && document.getElementById("illuvideo") != null) {
        pt_DTvideoisloaded = true;
        pt_MDvideoisloaded = false;
        pt_SMvideoisloaded = false;
        $('#illuvideo source').attr('src', $('#illuvideo').data('video-lg'));
        myvid = document.getElementById("illuvideo");
        myvid.load();
      }
      
      if(document.getElementById("illuvideoMobile") != null && windowWidth < 992) {
        
        if(windowWidth > 785 && windowWidth < 992 && !pt_MDvideoisloaded) {
          pt_DTvideoisloaded = false;
          pt_MDvideoisloaded = true;
          pt_SMvideoisloaded = false;
          $('#illuvideoMobile source').attr('src', $('#illuvideoMobile').data('video-md'));
          myvid = document.getElementById("illuvideoMobile");
          myvid.load();
        }
        if(windowWidth < 786 && !pt_SMvideoisloaded) {
          pt_DTvideoisloaded = false;
          pt_MDvideoisloaded = false;
          pt_SMvideoisloaded = true;
          $('#illuvideoMobile source').attr('src', $('#illuvideoMobile').data('video-sm'));
          myvid = document.getElementById("illuvideoMobile");
          myvid.load();
        }
      }
      
      });

    $(window).trigger('resize');
  }
});